import * as THREE from 'three'

/**
 * Lightformers - moving lights that create dynamic reflections.
 * Uses PointLights (cheap) instead of RectAreaLights (expensive).
 * The HDR environment map handles the main reflections;
 * these just add moving highlights on the car body.
 */

export function createLightformers(scene) {
    const lightformers = []

    const configs = [
        // Top key light (static)
        { color: 0xffffff, intensity: 80, position: [0, 8, 0], moving: false },
        // Orbiting side lights
        { color: 0xffeedd, intensity: 50, orbit: { radius: 6, speed: 0.3, offset: 0, height: 4 }, moving: true },
        { color: 0xddeeff, intensity: 50, orbit: { radius: 6, speed: -0.2, offset: Math.PI, height: 5 }, moving: true },
        // Front/rear accents
        { color: 0xffffff, intensity: 35, orbit: { radius: 6, speed: 0.15, offset: Math.PI / 2, height: 3 }, moving: true },
        { color: 0xffeeff, intensity: 40, orbit: { radius: 7, speed: -0.25, offset: -Math.PI / 3, height: 3.5 }, moving: true },
    ]

    configs.forEach(cfg => {
        const light = new THREE.PointLight(cfg.color, cfg.intensity, 0) // distance=0 = no limit
        if (cfg.position) light.position.set(...cfg.position)
        scene.add(light)
        lightformers.push({ light, config: cfg })
    })

    let speedMultiplier = 1.0
    let lastTime = 0
    let accumT = 0

    function setSpeed(s) { speedMultiplier = s }

    function update(time) {
        const dt = time - lastTime
        lastTime = time
        accumT += dt * speedMultiplier
        const t = accumT
        for (let i = 0; i < lightformers.length; i++) {
            const lf = lightformers[i]
            if (!lf.config.moving) continue
            const orb = lf.config.orbit
            const angle = t * orb.speed + orb.offset
            lf.light.position.x = Math.cos(angle) * orb.radius
            lf.light.position.z = Math.sin(angle) * orb.radius
            lf.light.position.y = orb.height + Math.sin(t * orb.speed * 2 + orb.offset) * 0.5
        }
    }

    return { update, setSpeed }
}
